let sitio: string = 'https://bio.posix.mx/api/method/bioadvanced.agenda_movil.'


export class ApiController {
  data: any;

  async whitelabel() {
    let resp =  await fetch(  sitio + "whitelabel"  )
    return resp.json()
  }

  // RG - 20Jun24 - Restablecer contrasena (envia correo al cliente)
  async retrieve_pass(usr) {
      try {
        let resp = await fetch(  sitio + "retrieve_pass?usr=" +  usr  )
        return resp.json()
      } catch(err) {
        alert(err)
      }
  }
  async contact_us() {
      try {
        let resp = await fetch(  sitio + "contact_us"  )
        return resp.json()
      } catch(err) {
        alert(err)
      }
  }

  // RG - 31Mar22 Metodos del tutor...Login directo, en metodo custom
  async login(usr,pwd) {
      try {
        let resp = await fetch(  sitio + "login?usr=" +  usr + "&pwd=" +  pwd )
        return resp.json()
      } catch(err) {
        alert(err)
        // alert('Invalid Username or Password. Please Try Again.');
      }
  }

  async therapies() {
    try {
      let resp = await fetch(  sitio + "therapies")
      return resp.json()
    } catch(err) {
      alert('Please Try Again.');
    }
  }

  async therapy(id) {
    try {
      let resp = await fetch(  sitio + "therapy?id=" +  id )
      return resp.json()
    } catch(err) {
      alert('Please Try Again.');
    }
  }
  async therapy_notif(visit,therapy_id,email) {
    try {
      let resp = await fetch(  sitio + "therapy_notif?visit=" + visit+"&therapy="+therapy_id+"&email="+email)
      return resp.json()
    } catch(err) {
      alert('Please Try Again.');
    }
  }

  async notifications(usr) {
    try {
      let resp = await fetch(  sitio + "notifications?usr=" +  usr )
      return resp.json()
    } catch(err) {
      alert('Please Try Again.');
    }
  }
  async visits(usr) {
    try {
      let resp = await fetch(  sitio + "visits?usr=" +  usr )
      return resp.json()
    } catch(err) {
      alert('Please Try Again.');
    }
  }

  async visit(id) {
    try {
      let resp = await fetch(  sitio + "visit?id=" +  id )
      return resp.json()
    } catch(err) {
      alert('Please Try Again.');
    }
  }



  async centro_ayuda() {
    let resp = await fetch(  sitio + "centro_ayuda" )
    return resp.json()
  }

  async privacidad() {
    let resp = await fetch(  sitio + "privacidad" )
    return resp.json()
  }

  async soporte_app(usr,nombre,message,email,phone,subject) {
    // console.log(message)
    let data = {
      usr: usr,
      email: email,
      phone: phone,
      nombre: nombre,
      subject: subject,
      message: message
    }

  let resp = await fetch(sitio + "soporte_app", {
              method: 'POST',
              body: JSON.stringify(data),
              headers: {'Content-Type': 'application/json','Accept': 'application/json'}
    })
    return resp.json()
  }

  async movil_app_config() {
    let resp = await fetch(  sitio + "movil_app_config")
    return resp.json()
  }



  async customer_items(usr) {
    try {
      let resp = await fetch(  sitio + "customer_items?usr=" +  usr )
      return resp.json()
    } catch(err) {
      alert('Intenta de nuevo.');
    }
  }

  async customer_info(usr) {
    try {
      let resp = await fetch(  sitio + "customer_info?usr=" +  usr )
      return resp.json()
    } catch(err) {
      alert('Intenta de nuevo.');
    }
  }

  async notification_token(usr,token,platform) {
    let data = {
      usr: usr,
      token: token,
      platform: platform,
      user_type: 'Patient'
    };
    console.log('desde api ' ,data)

    try {
      let device_token = await fetch( sitio + "notification_token", {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {'Content-Type': 'application/json','Accept': 'application/json'}
      })
      return device_token.json()
    } catch(err) {
      // alert('No se envio el token.');
    }
  }

  async get_ivs(fecha: Date){
    try {
      let resp = await fetch(  sitio + "get_agenda_iv?fecha="+fecha)
      return resp.json()
    } catch(err) {
      alert('Please Try Again.');
    }
  }

  async update_ivs(session,name,terapia,tipo,user){
    try {
      let resp = await fetch(  sitio + "update_ivs?session="+session+"&name="+name+"&terapia="+terapia+"&tipo="+tipo+"&user="+user)
      return resp.json()
    } catch(err) {
      alert('Please Try Again.');
    }
  }

  async finish_ivs(session,name,terapia,tipo,user){
    try {
      let resp = await fetch(  sitio + "finish_ivs?session="+session+"&name="+name+"&terapia="+terapia+"&tipo="+tipo+"&user="+user)
      return resp.json()
    } catch(err) {
      alert('Please Try Again.');
    }
  }

  async get_iny(fecha: Date){
    try {
      let resp = await fetch(  sitio + "get_agenda_iny?fecha="+fecha)
      return resp.json()
    } catch(err) {
      alert('Please Try Again.');
    }
  }

  async update_iny(session,name,terapia,tipo,user){
    try {
      let resp = await fetch(  sitio + "update_ivs?session="+session+"&name="+name+"&terapia="+terapia+"&tipo="+tipo+"&user="+user)
      return resp.json()
    } catch(err) {
      alert('Please Try Again.');
    }
  }


}

export const ApiData = new ApiController();
